module.exports = __webpack_public_path__ + "img/mobilepay.b0545874.png";